<template>
  <div class="my-2">
    <ValidationObserver ref="observer">
      <ValidationProvider rules="required" v-slot="{ errors }" name="category">
        <eb-select
          v-if="!isBillTo"
          type="text"
          v-model="office.category"
          :options="categoryOptions"
          label="label"
          placeholder="Select Category *"
          class="w-100"
        ></eb-select>
        <span class="validate-error">{{ errors[0] }}</span>
      </ValidationProvider>

      <slot name="name" :data="office.officeName">
        <ValidationProvider
          rules="required|min:3|alpha_spaces"
          v-slot="{ errors }"
          name="office name"
        >
          <CustInput
            inputType="text"
            :inputId="`name`"
            labelText="Office Name *"
            v-model="office.officeName"
            class="mt-3 w-100"
          />
          <span class="validate-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </slot>

      <!-- Phone Input -->
      <b-row class="my-3" v-for="(p, idx) in office.phone" :key="p + `${idx}`">
        <b-col v-if="!setValues" sm="12" md="9" class="pr-0">
          <ValidationProvider
            :rules="{ required: true, min: 15, max: 15, regex: /^[0-9+ ]+$/ }"
            v-slot="{ errors }"
            name="phone number"
          >
            <TelInput
              :inputType="`number`"
              v-model="p.number"
              @validate="(e) => isValidate(e, p)"
              class="m-0 same-height"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col v-if="!setValues" sm="12" md="3" class="pl-0">
          <b-button
             :variant="p.isRemovable ? 'danger' : 'primary'"
             class="btn-special btn-no-left-radius" 
             size="lg"
             @click="onClickPhoneButton(p, idx)"
            >
            <i :class="p.isRemovable ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i>
             <span class="ml-1">{{ p.isRemovable ? 'Remove' : 'Add New' }}</span>
          </b-button>
        </b-col>
      </b-row>

      <!-- Email Input -->
      <b-row class="my-3" v-for="(e, idx) in office.email" :key="idx">
        <b-col sm="12" md="9" class="pr-0" v-if="!setValues">
          <ValidationProvider
            rules="required|email|no-capital-first-letter"
            v-slot="{ errors }"
            name="email"
          >
            <CustInput
              inputType="email"
              :inputId="`mail`"
              labelText="Email *"
              v-model="e.mailId"
              autocomplete="off"
              class="same-height"
            />
            <span v-if="errors[0]" class="validate-error"
              >{{ errors[0] }} (First letter should be small)</span
            >
          </ValidationProvider>
        </b-col>
        <b-col v-if="!setValues" sm="12" md="3" class="pl-0">
          <b-button
          :variant="e.isRemovable ? 'danger' : 'primary'"
           class="btn-special btn-no-left-radius" 
             size="lg"
            @click="onClickEamilButton(e, idx)"
          >
            <i :class="e.isRemovable ? 'fa fa-minus-circle' : 'fa fa-plus-circle'"></i>
            <span class="ml-1">{{ e.isRemovable ? 'Remove' : 'Add New' }}</span>
          </b-button>
        </b-col>
      </b-row>

      <!-- Location Input -->
      <b-row>
        <b-col sm="12" md="12">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, validate }"
            name="office location"
          >
            <GmapAutocomplete
              @place_changed="placechange1"
              @change="validate"
              class=" mb-3 w-100 location-search"
              placeholder="Enter office location *"
              :options="{
                fields: ['geometry', 'formatted_address', 'address_components'],
              }"
            ></GmapAutocomplete>
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>

      <!-- Country/State/City -->
      <b-row>
        <b-col sm="12" md="12">
          <ValidationProvider rules="required" v-slot="{ errors }" name="Country">
            <CustInput
              type="text"
              :inputId="`country`"
              readonly
              v-model="office.address.country"
              labelText="Country"
              class=" w-100"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" md="6">
          <CustInput
            type="text"
            :inputId="`state`"
            readonly
            v-model="office.address.state"
            labelText="State"
            class="w-100"
          />
        </b-col>
        <b-col sm="12" md="6">
          <CustInput
            type="text"
            :inputId="`city`"
            readonly
            v-model="office.address.city"
            labelText="City"
            class="w-100"
          />
        </b-col>
      </b-row>

      <!-- Zipcode Input -->
      <b-row>
        <b-col sm="12" md="12">
          <ValidationProvider rules="required|min:6" v-slot="{ errors }" name="zipcode">
            <CustInput
              :inputType="`text`"
              :inputId="`zipcode`"
              v-model="office.address.zip"
              labelText="Zipcode *"
              autocomplete="off"
              class="w-100"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <DynamicInput
            :fields="externalInfoPartner || []"
            :visibility="isVisible"
            ref="dynamicForm"
            @update:formData="handleExtendedAttributesUpdate"
          />
        </b-col>
      </b-row>
      <slot name="footer-button" :data="{ office, extendedAttributes }"> </slot>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, Validator } from "vee-validate";
import CustInput from "@/components/Common/CustomInput";
import TelInput from "@/components/Common/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import locationMixins from "@/mixins/addressLocation";
import { mapState } from "vuex";
import DynamicInput from "@/components/Partner/additionalInfo.vue";

export default {
  name: "OfficeStepper",
  mixins: [locationMixins],
  data() {
    return {
      externalInfoPartner: [],
      countries: [],
      states: [],
      cities: [],
      tenant: null,
      extendedAttributes: {},
      office: {
        category: null,
        officeName: "",
        email: [
          {
            mailId: "",
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
          },
        ],
        phone: [
          {
            country: {
              dialCode: null,
              iso2: null,
              name: null,
            },
            number: null,
            type: "5cb700733aa1ea2920089566",
            isRemovable: false,
            text: "Add New",
            isValid: false,
          },
        ],
        address: {
          country: "",
          area: "",
          state: "",
          city: "",
          street1: "",
          street2: "",
          zip: "",
          houseNumber: "",
          location: {
            coordinates: [0, 0],
          },
        },
      },
    };
  },
  props: {
    tenants: Array,
    officeData: Object,
    isBillTo: {
      type: Boolean,
      default: false,
    },
    setValues: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DynamicInput,
    ValidationProvider,
    ValidationObserver,
    CustInput,
    TelInput,
    ebSelect,
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
    }),
    isVisible() {
      return this.externalInfoPartner.length >= 0;
    },
    categoryOptions() {
      let userdata = this.$currentUserData;
      if (this.$currentUserData.category === "ZONAL_OPERATION_HEAD") {
        return [
          {
            label: "Distributor",
            value: "DISTRIBUTOR",
          },
        ];
      }
      if (this.$userRole === "Tenant") {
        return [
          {
            label: "Seller",
            value: "SELLER",
          },
          {
            label: "Distributor",
            value: "DISTRIBUTOR",
          },
          {
            label: "Supplier",
            value: "SUPPLIER",
          },
        ];
      } else if (this.$userRole === "Partner" && userdata.category === "DISTRIBUTOR") {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
            {
              label: "Dealer",
              value: "DEALER",
            },
            {
              label: "Sub Dealer",
              value: "SUB_DEALER",
            },
          ];
        }
      } else if (this.$userRole === "Partner" && userdata.category === "DEALER") {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
            {
              label: "SUB DEALER",
              value: "SUB_DEALER",
            },
          ];
        }
      } else if (this.$userRole === "Partner" && userdata.category === "SELLER") {
        {
          return [
            {
              label: "Manufacturer",
              value: "MANUFACTURER",
            },
          ];
        }
      } else if (this.$userRole === "Partner" && userdata.category === "SUB_DEALER") {
        {
          return [
            {
              label: "Seller",
              value: "SELLER",
            },
          ];
        }
      }
    },
  },
  methods: {
    handleExtendedAttributesUpdate(updatedData) {
      this.extendedAttributes = updatedData;
    },
    async getAttributeList() {
      this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.externalInfoPartner = this.extendedList.externalInfoPartner || [];
      });
    },
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    placechange1(e) {
      this.placechange(e);
      this.$emit("place_changed", e);
      let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
      if (mapdata) {
        this.office.address.country = mapdata.data.Country;
        this.office.address.city = mapdata.data.City;
        this.office.address.state = mapdata.data.State;
        this.office.address.area = mapdata.data.Area ? mapdata.data.Area : "";
        this.office.address.zip = mapdata.data.zip ? mapdata.data.zip : "";
        this.office.address.location = {
          coordinates: [mapdata.Lng, mapdata.Lat],
        };
      }
    },
    useOfficeData() {
      if (!this.setValues) return;
     this.office = this.officeData.office;
    },
    isValidate(e, p) {
      p.country = { ...e.country };
      p.isValid = e.isValid;
    },
    getCountry(payload) {
      this.setState(payload.id);
      this.office.address.country = payload.name;
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.email.push({
          mailId: "",
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.email.splice(idx, 1);
    },
    async onClickPhoneButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.office.phone.push({
          country: {
            dialCode: null,
            iso2: null,
            name: null,
          },
          number: null,
          type: "5cb701203aa1ea2920089568",
          isRemovable: true,
          text: "Remove",
        });
      else this.office.phone.splice(idx, 1);
    },
  },
  mounted() {
    this.getAttributeList();
    Validator.extend("no-capital-first-letter", {
      validate(value) {
        return value[0] !== value[0].toUpperCase();
      },
    });
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: "Lato";
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
.same-height {
  height: 39px; /* Set a fixed height */
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

.btn-special {
   border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size:small;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 120px; 
  
  color: white;
}

.btn-no-left-radius {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.statemargintop {
  margin-top: -15px !important;
}
.streetmargintop {
  margin-top: -8px !important;
}

@media (max-width: 768px) {
  .same-height {
    height: 35px; /* Adjust height for smaller screens */
  }
}
@media (max-width: 768px) {
  .location-search {
    font-size: 0.9rem;
    height: 35px;
  }
  .btn-special {
    margin-top: 1rem;
  }
}
</style>
<style>
.vue-tel-input {
  border-radius: 0px !important;
  height: 39px !important;
  border: 1px solid #dee2e6 !important;
}

</style>
